import { Component } from '@angular/core';

@Component({
  selector: 'app-register-for-exam-form',
  templateUrl: './register-for-exam-form.component.html',
  styleUrls: ['./register-for-exam-form.component.scss'],
})
export class RegisterForExamFormComponent {}
